import { cn } from '@/lib/utils'

/**
 * PulseSignal mark, the source SVG verbatim. Two solid orange (#F97316)
 * mountain-pulse silhouettes plus a small green (#10B981) accent dot.
 * These three hex values are brand identity and intentionally NOT mapped
 * to the tailwind palette tokens.
 *
 * `cutColor` is kept on the prop signature for source-compatibility
 * with prior callers but is no longer used.
 */
export function LogoMark({
  className,
  size = 28,
  cutColor: _cutColor,
}: {
  className?: string
  size?: number
  cutColor?: string
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 624 648"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('shrink-0', className)}
      aria-hidden
    >
      <g transform="translate(0,648) scale(0.1,-0.1)">
        <path
          fill="#F97316"
          fillRule="evenodd"
          d="M3218 5430 c-27 -23 -60 -68 -83 -112 -21 -40 -50 -89 -65 -108 -15
-19 -39 -57 -54 -85 -25 -48 -59 -99 -126 -192 -16 -23 -40 -66 -54 -95 -13
-29 -38 -66 -56 -83 -18 -16 -46 -59 -62 -95 -16 -36 -36 -72 -43 -80 -8 -9
-31 -46 -52 -82 -21 -36 -51 -83 -66 -104 -39 -54 -89 -136 -133 -219 -20 -38
-53 -88 -73 -111 -20 -23 -42 -58 -50 -79 -7 -20 -47 -90 -88 -154 -42 -64
-85 -132 -98 -151 -21 -34 -69 -117 -110 -190 -10 -19 -35 -55 -53 -80 -19
-25 -42 -61 -50 -80 -8 -19 -31 -60 -51 -90 -74 -109 -121 -185 -210 -337
-127 -218 -237 -395 -290 -464 -18 -24 -38 -55 -44 -69 -16 -36 -124 -217
-162 -270 -52 -74 -106 -181 -103 -204 2 -12 17 -28 38 -39 33 -16 92 -17
1030 -13 547 3 1015 5 1040 4 25 -1 364 -2 753 -3 l709 0 30 35 c16 19 59 80
95 135 36 55 76 111 88 125 13 14 40 57 60 95 20 39 47 81 60 95 39 42 105
152 105 175 0 12 -11 37 -25 56 -13 19 -36 54 -51 79 -15 25 -42 66 -60 91
-19 25 -43 67 -54 94 -22 51 -61 106 -119 168 -59 62 -90 67 -435 66 -349 -1
-403 -6 -425 -39 -9 -13 -37 -49 -63 -79 -25 -30 -62 -82 -80 -115 -58 -101
-139 -230 -160 -253 -23 -24 -118 -183 -118 -197 0 -5 -24 -45 -54 -90 -29
-44 -70 -108 -91 -141 -72 -114 -86 -132 -120 -151 -39 -21 -75 -9 -92 30 -6
12 -9 228 -8 536 3 596 8 557 -101 768 -148 288 -189 600 -113 858 11 38 28
99 38 135 20 73 74 177 131 254 21 28 52 73 68 100 37 59 194 207 275 259 31
20 60 42 64 49 4 8 22 24 40 37 60 43 61 68 11 157 -25 43 -59 107 -76 143
-72 152 -132 183 -214 110z"
        />
        <path
          fill="#F97316"
          fillRule="evenodd"
          d="M4356 4569 c-179 -61 -242 -109 -335 -253 -69 -107 -80 -145 -81
-272 0 -87 2 -96 40 -172 57 -113 176 -247 233 -262 23 -7 82 -25 131 -42 78
-27 94 -29 130 -20 175 44 235 61 261 75 58 29 143 132 188 224 l42 88 0 130
0 130 -39 82 c-67 143 -222 258 -401 299 -80 18 -99 17 -169 -7z"
        />
      </g>
      <circle cx="556" cy="428" r="29.4" fill="#10B981" />
    </svg>
  )
}

export function Logo({
  className,
  accentClassName = 'text-ink-900',
  wordClassName,
  size = 26,
  showWordmark = true,
  cutColor,
}: {
  className?: string
  accentClassName?: string
  wordClassName?: string
  size?: number
  showWordmark?: boolean
  cutColor?: string
}) {
  return (
    <span className={cn('inline-flex items-center gap-2', className)}>
      <span className={accentClassName}>
        <LogoMark size={size} cutColor={cutColor} />
      </span>
      {showWordmark && (
        <span
          className={cn(
            'text-[19px] font-semibold tracking-tight',
            wordClassName,
          )}
        >
          PulseSignal
        </span>
      )}
    </span>
  )
}
